export const ADD_NEW_COMPANY = `
  mutation (
    $name: String!,
    $email: String!,
    $mobile: String,
    $address: String,
    $gst_number: String,
    $discount: Int
  ) {
    add_new_company(
      name: $name,
      email: $email,
      mobile: $mobile,
      address: $address,
      gst_number: $gst_number,
      discount: $discount
    ) {
      message
      _id
    }
  }
`;


export const UPDATE_COMPANY = `
  mutation (
    $_id: String!,
    $name: String,
    $address: String,
    $gst_number: String,
    $mobile: String
  ) {
    update_company(
      _id: $_id,
      name: $name,
      address: $address,
      gst_number: $gst_number,
      mobile: $mobile
    ) {
      message
      _id
    }
  }
`;

export const LIST_ALL_COMPANIES = `
  query (
    $pageSize: Int,
    $pageNumber: Int,
    $isForDropdown: Boolean
  ) {
    list_all_hotel_companies(
      page_size: $pageSize,
      page_number: $pageNumber,
      is_for_dropdown: $isForDropdown
    ) {
      message
      data {
        _id
        name
        email
        mobile
        address
        gst_number
        is_active
      }
      hasMore
    }
  }
`;
